import { findNearestNumber } from "../../../util/tradepanel"
import { getStrikeAndStrikeData } from "../../../pages/home/openInterestHeader/MultiStrikesMenu/MultiStrikesMenu"
import { DropDownExpiries } from "../../../reducer/options.reducer"
import { Security } from "../../../proto/generated/security"
import { Snapshot } from "../../../reducer/security.reducer"
import { Exchange } from "../../../proto/generated/common"
import { fetchOptionExpiriesV2 } from "../../../util/options"
import { getSecurityAsync } from "../../../util/security"

const stringToExchange = (exchange: string): Exchange => {
    return Exchange[exchange as keyof typeof Exchange] ?? Exchange.UNRECOGNIZED;
};


const updateUtils = async (dispatch: any, newLayoutId: string, updatedParsedLayout: any, optionExpiriesData: DropDownExpiries[] | undefined, security: Security, key: string, underlyingSnaphot: Snapshot, type: string, w_key : string , i : number) => {
    let dropdownExpiries = optionExpiriesData || []
    if (!optionExpiriesData) {
        const exchange = stringToExchange(key.split(":")[0]);
        const code = key.split(":")[1];
        try {
            dropdownExpiries = await fetchOptionExpiriesV2({ exchange: exchange as Exchange, code: code }, dispatch);
        } catch (error) {
            console.error("Error fetching option expiries:", error);
            return; 
        }
    }

    if(dropdownExpiries.length === 0) return ;

    let updatedPane = {}
    const expiryName = dropdownExpiries[0].expiry.name || ''
    let expiryIndex = dropdownExpiries?.findIndex(o => o.expiry.name === expiryName)

    if (expiryIndex === -1) {
        console.error("Expiry not found in dropdownExpiries");
        return;
    }

    const expiryDataFinal = dropdownExpiries?.[expiryIndex as number]

    const w = updatedParsedLayout.widgets[w_key];
    
    const paneSecurities = w?.settings?.securities

    const atmStrike = findNearestNumber(
        expiryDataFinal?.strikesArray,
        underlyingSnaphot?.lastTradedPrice
    )
    const atm = expiryDataFinal.strikes.find(s => s.strike === atmStrike)
    const isDecimal = expiryDataFinal.strikes.some(
        s => !Number.isInteger(s.strike / (security?.priceMultiplier ?? 100))
    )
    const strikeData = atm ? getStrikeAndStrikeData(atm, security?.priceMultiplier ?? 100, isDecimal) : null;

    for( let security of Object.keys(paneSecurities)){
        if (await getSecurityAsync(security)) {
            // Security is valid
            break;
        } else {
            // Security is expired, return update widget & security groups values
            updatedPane  = {...(strikeData?.strikeData || {})}
        }
    }

    const atmIndex = expiryDataFinal.strikes.findIndex(
        s => s.strike === atmStrike
    )
    if (type === "MULTI_STRIKE_CHART") {
        if (atm) {
            const { strike, strikeData } = getStrikeAndStrikeData(
                atm,
                security?.priceMultiplier ?? 100,
                isDecimal
            )
            let data = {
                [strike]: strikeData.callPut
            }

            const a = [3, 5, 7, 9]
            a.forEach((x) => {
                if (i >= x) {
                    const index = x === 3 ? 1 : x === 5 ? 2 : x === 7 ? 3 : 4
                    const atm1 = expiryDataFinal.strikes[atmIndex - index]
                    const atm2 = expiryDataFinal.strikes[atmIndex + index]

                    if (atm1 && atm2) {
                        const { strike: strike1, strikeData: strikeData1 } = getStrikeAndStrikeData(
                            atm1,
                            security?.priceMultiplier ?? 100,
                            isDecimal
                        )
                        const { strike: strike2, strikeData: strikeData2 } = getStrikeAndStrikeData(
                            atm2,
                            security?.priceMultiplier ?? 100,
                            isDecimal
                        )
                        data = {
                            [strike1]: strikeData1.callPut,
                            ...data,
                            [strike2]: strikeData2.callPut
                        }
                    }
                }
            })
            return {
                updatedPane : updatedPane,
                securities: { ...data },
                expiry: expiryName
            };
        }
    }
    else if (type === "CHART") {
        if (atm) {
            const { strike, strikeData } = getStrikeAndStrikeData(
                atm,
                security?.priceMultiplier ?? 100,
                isDecimal
            )
            let data = {
                [strike]: strikeData.callPut
            }
            const a = [3, 5, 7, 9]
            a.forEach((x) => {
                if (i >= x) {
                    const index = x === 3 ? 1 : x === 5 ? 2 : x === 7 ? 3 : 4
                    const atm1 = expiryDataFinal.strikes[atmIndex - index]
                    const atm2 = expiryDataFinal.strikes[atmIndex + index]

                    if (atm1 && atm2) {
                        const { strike: strike1, strikeData: strikeData1 } = getStrikeAndStrikeData(
                            atm1,
                            security?.priceMultiplier ?? 100,
                            isDecimal
                        )
                        const { strike: strike2, strikeData: strikeData2 } = getStrikeAndStrikeData(
                            atm2,
                            security?.priceMultiplier ?? 100,
                            isDecimal
                        )
                        data = {
                            [strike1]: strikeData1.callPut,
                            ...data,
                            [strike2]: strikeData2.callPut
                        }
                    }
                }
            })
            return {
                updatedPane : updatedPane,
                securities: { ...data },
                expiry: expiryName
            };
        }

    }
    else {

    }
}

export default updateUtils;